<template>
    <div>
        <el-menu-item v-if="!obj.smenuList || obj.smenuList.length===0" :index="obj.vc_url" >
          <i class="el-icon-collection-tag"></i>  {{obj.vc_name}}
        </el-menu-item>
        <div v-else>
            <el-submenu :index="obj.vc_url">
                <template slot="title">
                    <i class="el-icon-collection-tag"></i>   {{obj.vc_name}}
                </template>
                <left-menu-item v-for="(item,index) in obj.smenuList" :key="index" :obj="item"></left-menu-item>
            </el-submenu>
        </div>
    </div>
</template>

<script>
    import LeftMenuItem from "./LeftMenuItem";
    export default {
        name: 'LeftMenuItem',
        components:{LeftMenuItem},
        props:{
            obj:Object,
        },
        data(){
            return{

            }

        }
    }
</script>
<style  lang="scss" scoped>


</style>